module.exports = __webpack_public_path__ + "static/media/codeIcon.affa8e04.svg";